import type { Transform } from "@/api/mapperApi";

export interface TransformExplanation {
  title: string;
  text: string;
  table?: Array<{ code: string; meaning: string }>;
  raw?: string;
}

/** Turn a transform JSON into a plain-language, non-technical descriptor for the BA. */
export function explainTransform(t: Transform): TransformExplanation {
  switch (t.type) {
    case "identity":
      return { title: "Unverändert", text: "Der Wert wird unverändert übernommen." };
    case "code_lookup": {
      const table = Object.entries(t.table ?? {}).map(([code, meaning]) => ({ code, meaning }));
      return {
        title: "Code-Übersetzung",
        text: "Der EDI-Code wird in einen sprechenden BO4E-Wert übersetzt.",
        table: table.length ? table : undefined,
      };
    }
    case "date_format":
      return {
        title: "Datum umformen",
        text: "EDIFACT-Datum (z. B. CCYYMMDDHHMM) wird in ISO 8601 umgewandelt — z. B. 202506050200 → 2025-06-05T02:00:00Z.",
      };
    case "const":
      return { title: "Fester Wert", text: `Es wird immer der feste Wert „${t.value ?? ""}" gesetzt.` };
    default:
      return {
        title: "Erweiterte Regel",
        text: "Diese Zuordnung nutzt eine individuelle Transformationsregel.",
        raw: t.raw ?? undefined,
      };
  }
}
